document.addEventListener('DOMContentLoaded', (event) => {
    // Load state from new Vercel API
    function loadSavedProducts() {
        const buttons = document.querySelectorAll('.save_product_button[data-customer-id]');
        if (buttons.length === 0) return;

        const customerId = buttons[0].getAttribute('data-customer-id');

        if (!customerId) {
            return;
        }

        fetch(`https://clnf.vercel.app/api/product-wishlist/get?customerId=${customerId}`)
            .then(res => res.json())
            .then(response => {
                // Handle array or object structure
                let items = Array.isArray(response) ? response : (response.wishlist || response.products || response.data || []);

                if (items && items.length > 0) {
                    var markedSet = new Set();
                    items.forEach(function (item) {
                        var productId = item.productId || item.product_id;

                        // We use product ID for the main check
                        if (productId && !markedSet.has(productId)) {
                            // Find buttons for this product
                            const productButtons = document.querySelectorAll(`.save_product_button[data-product-id="${productId}"]`);
                            productButtons.forEach(btn => {
                                btn.classList.add('active');
                                const icon = btn.querySelector('i, svg.wishlist-icon');
                                if (icon) {
                                    if (icon.tagName.toLowerCase() === 'svg') {
                                        icon.classList.add('filled');
                                    } else {
                                        icon.classList.remove('fa-heart-o');
                                        icon.classList.add('fa-heart');
                                    }
                                }
                                const text = btn.querySelector('.save-text');
                                if (text && !text.classList.contains('sr-only')) {
                                    text.textContent = 'Saved';
                                }
                            });

                            markedSet.add(productId);
                        }
                    });
                }
            })
            .catch(error => {
                console.error('Error loading saved products:', error);
            });
    }

    loadSavedProducts();

    // assets/filtering.js replaces #CollectionProductGrid's innerHTML wholesale on every
    // AJAX filter/sort/pagination action and dispatches 'paginate' afterward (see its
    // renderProductGrid()). The freshly-injected product cards are plain server-rendered
    // markup with no saved/active state baked in, so without this the wishlist hearts on
    // a filtered/sorted grid always render as "unsaved" - even for products actually in
    // the customer's wishlist - until a full page reload. Re-run the same state fetch.
    document.addEventListener('paginate', loadSavedProducts);

    // Event Delegation for dynamic elements
    document.addEventListener('click', async function (e) {
        // Handle click on button or its children
        const btn = e.target.closest('.save_product_button');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation(); // Stop propagation just in case

        let isAdding = !btn.classList.contains('active');
        const productId = btn.getAttribute('data-product-id');

        // Optimistic UI update immediately
        // Note: If we redirect to login later, this UI state will be lost, which is fine/expected.
        const allButtonsForProduct = document.querySelectorAll(`.save_product_button[data-product-id="${productId}"]`);
        allButtonsForProduct.forEach(b => {
            updateButtonState(b, isAdding);
        });

        // Helper to update button state
        function updateButtonState(b, active) {
            if (active) {
                b.classList.add('active');
                const icon = b.querySelector('i, svg.wishlist-icon');
                if (icon) {
                    if (icon.tagName.toLowerCase() === 'svg') {
                        icon.classList.add('filled');
                    } else {
                        icon.classList.remove('fa-heart-o');
                        icon.classList.add('fa-heart');
                    }
                }
                const text = b.querySelector('.save-text');
                if (text && !text.classList.contains('sr-only')) {
                    text.textContent = 'Saved';
                }
            } else {
                b.classList.remove('active');
                const icon = b.querySelector('i, svg.wishlist-icon');
                if (icon) {
                    if (icon.tagName.toLowerCase() === 'svg') {
                        icon.classList.remove('filled');
                    } else {
                        icon.classList.remove('fa-heart');
                        icon.classList.add('fa-heart-o');
                    }
                }
                const text = b.querySelector('.save-text');
                if (text && !text.classList.contains('sr-only')) {
                    text.textContent = 'Add to Wishlist';
                }
            }
        }

        // --- ROBUST DATA GATHERING START ---

        let variantId = btn.getAttribute('data-variant-id');
        let productTitle = btn.getAttribute('data-product-title');
        let productHandle = btn.getAttribute('data-product-handle');
        let productImage = btn.getAttribute('data-product-image');
        let productUrl = btn.getAttribute('data-product-url');
        let productPrice = btn.getAttribute('data-product-price');

        // 0. CHECK GLOBAL DATA OBJECT (Preferred Method)
        if (window.ClnfWishlistData && window.ClnfWishlistData[productId]) {
            const globalData = window.ClnfWishlistData[productId];

            // Fix Protocol relative URL for image
            let gImage = globalData.image;
            if (gImage && gImage.startsWith('//')) {
                gImage = 'https:' + gImage;
            }

            // Always prioritize global object data to avoid "null" string issues from attributes
            if (globalData.title) productTitle = globalData.title;
            if (globalData.handle) productHandle = globalData.handle;
            if (gImage) productImage = gImage;
            if (globalData.url) productUrl = globalData.url;
            if (globalData.price) productPrice = globalData.price;

            // Only fall back to global variant if local is missing/null
            if ((!variantId || variantId === 'null') && globalData.variantId) {
                variantId = globalData.variantId;
            }
        }

        // Debug Log: Check what we start with
        if (!productHandle || !productTitle) {
            console.warn("Wishlist: Missing data on button. attempting recovery.", {
                button: btn,
                html: btn.outerHTML,
                productId
            });
        }

        // 1. Recover Handle (The Key to everything)
        if (!productHandle) {
            // A. Try URL on button
            if (productUrl) {
                const match = productUrl.match(/\/products\/([^\/\?]+)/);
                if (match) productHandle = match[1];
            }

            // B. Try Window Location (If on Product Page)
            if (!productHandle && window.location.pathname.includes('/products/')) {
                const match = window.location.pathname.match(/\/products\/([^\/\?]+)/);
                if (match) {
                    productHandle = match[1];
                }
            }

            // C. Try Global `all_products` variable (if exists from favorites script)
            if (!productHandle && window.all_products && variantId) {
                // iterate keys
                for (const [h, variants] of Object.entries(window.all_products)) {
                    if (variants[variantId]) { // if variantId exists in this product
                        productHandle = h;
                        break;
                    }
                }
            }

            // D. Scrape Link from Container
            if (!productHandle) {
                const container = btn.closest('.grid-view-item') || btn.closest('.product-single-wrapper') || btn.closest('.grid__item') || document.body;
                // Look for links to products, but exclude links that might be irrelevant
                const links = container.querySelectorAll('a[href*="/products/"]');
                for (let link of links) {
                    const href = link.getAttribute('href');
                    const match = href.match(/\/products\/([^\/\?]+)/);
                    if (match) {
                        // Avoid grabbing the handle of a "Related Product" if we are scraping document.body
                        // Best guess: closest link is usually the right one
                        productHandle = match[1];
                        break;
                    }
                }
            }
        }

        // 2. Unification with Shopify API if data is incomplete but we have a handle
        // We do this check if we are ADDING and missing critical info
        if (isAdding && productHandle && (!productTitle || !productImage || !productPrice)) {
            try {
                const response = await fetch(`/products/${productHandle}.js`);
                if (response.ok) {
                    const productData = await response.json();

                    if (!productTitle) productTitle = productData.title;
                    if (!productImage) productImage = "https:" + productData.featured_image;
                    if (!productPrice) productPrice = (productData.price / 100).toFixed(2); // Shopify returns price in cents
                    if (!productUrl) productUrl = productData.url;

                    // Also try to fix variant ID if missing
                    if (!variantId && productData.variants && productData.variants.length > 0) {
                        variantId = productData.variants[0].id; // Default to first variant
                    }
                } else {
                    console.error("Failed to fetch product JSON:", response.status);
                }
            } catch (err) {
                console.error("Failed to fetch robust product details:", err);
            }
        }

        // 3. Last resort fallback: Scrape basic text from DOM if still missing
        if (!productTitle || !productPrice) {
            const container = btn.closest('.grid-view-item') || btn.closest('.product-single-wrapper') || document.body;
            if (!productTitle) {
                const titleEl = container.querySelector('.product-grid--title a, .product-details-product-title, h1.product_title');
                if (titleEl) productTitle = titleEl.innerText.trim();
            }
            if (!productPrice) {
                const priceEl = container.querySelector('.product-grid--price .money, #ComparePrice .money, .price .money');
                if (priceEl) productPrice = priceEl.innerText.trim();
            }
        }

        // --- ROBUST DATA GATHERING END ---

        // Validations
        if (!variantId || variantId === "null" || variantId === "") {
            variantId = productId;
        }

        // Check if logged in - MOVED AFTER DATA GATHERING
        let customerId = btn.getAttribute('data-customer-id');
        if (!customerId || customerId === "") {
            // Store the gathered robust data to LocalStorage
            const pendingItem = {
                productId,
                variantId,
                productHandle, // "handle"
                productTitle,  // "title"
                productImage,  // "image"
                productPrice,  // "price"
                productUrl,    // "url"
                timestamp: Date.now()
            };
            localStorage.setItem('pendingWishlistItem', JSON.stringify(pendingItem));

            window.location.href = '/account/login';
            return;
        }


        let apiUrl = isAdding ? 'https://clnf.vercel.app/api/product-wishlist/add' : 'https://clnf.vercel.app/api/product-wishlist/remove';
        let method = isAdding ? 'POST' : 'DELETE';

        let body = {};
        if (method === 'DELETE') {
            body = {
                customerId: Number(customerId),
                customer_id: Number(customerId),
                productId: Number(productId),
                product_id: Number(productId),
                variantId: Number(variantId),
                variant_id: Number(variantId)
            };
        } else {
            body = {
                customerId: Number(customerId),
                customer_id: Number(customerId),
                productId: Number(productId),
                product_id: Number(productId),
                variantId: Number(variantId),
                variant_id: Number(variantId),
                handle: productHandle,
                product_handle: productHandle,
                title: productTitle,
                product_title: productTitle,
                image: productImage,
                product_image: productImage,
                url: productUrl,
                product_url: productUrl,
                price: productPrice,
                product_price: productPrice
            };
        }

        fetch(apiUrl, {
            method: method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
            .then(async res => {
                if (res.status === 204) {
                    return {}; // Successful delete with no content
                }
                if (!res.ok) {
                    let errorMessage = 'Network response was not ok';
                    try {
                        const errorData = await res.json();
                        errorMessage = errorData.error || errorData.message || errorMessage;
                    } catch (e) {
                        console.error("Could not parse error JSON:", e);
                    }
                    throw new Error(errorMessage);
                }
                return res.json();
            })
            .then(response => {
                // If we are on the account page and removing, we might want to remove the row
                if (!isAdding && btn.closest('.wishlist-product-row')) {
                    const row = btn.closest('.wishlist-product-row');
                    row.style.opacity = '0';
                    setTimeout(() => row.remove(), 300);
                }
            })
            .catch(error => {
                console.error("Wishlist update failed:", error);
                // Rollback UI
                allButtonsForProduct.forEach(b => {
                    updateButtonState(b, !isAdding); // Revert state
                });
                alert('Something went wrong updating your wishlist. Please try again.');
            });

    });

    // Function to check and process pending items after login
    function checkPendingWishlistItems() {
        const pendingItemJson = localStorage.getItem('pendingWishlistItem');
        if (!pendingItemJson) return;

        // Robust Customer ID Detection
        let customerId = null;

        // 1. Try Global Variable from account.liquid
        if (typeof window.customer !== 'undefined') {
            customerId = window.customer;
        }

        // 2. Try Shopify Global Object
        if (!customerId && window.__st && window.__st.cid) {
            customerId = window.__st.cid;
        }

        // 3. Try DOM Buttons (Fallback)
        if (!customerId) {
            const buttons = document.querySelectorAll('.save_product_button[data-customer-id]');
            if (buttons.length > 0) {
                customerId = buttons[0].getAttribute('data-customer-id');
            }
        }

        if (!customerId) {
            return;
        }

        try {
            const pendingItem = JSON.parse(pendingItemJson);

            // Optional: Expiry check (e.g. 1 hour)
            const ONE_HOUR = 60 * 60 * 1000;
            if (Date.now() - pendingItem.timestamp > ONE_HOUR) {
                localStorage.removeItem('pendingWishlistItem');
                return;
            }

            // Construct payload
            const body = {
                customerId: Number(customerId),
                customer_id: Number(customerId),
                productId: Number(pendingItem.productId),
                product_id: Number(pendingItem.productId),
                variantId: Number(pendingItem.variantId),
                variant_id: Number(pendingItem.variantId),
                handle: pendingItem.productHandle,
                product_handle: pendingItem.productHandle,
                title: pendingItem.productTitle,
                product_title: pendingItem.productTitle,
                image: pendingItem.productImage,
                product_image: pendingItem.productImage,
                url: pendingItem.productUrl,
                product_url: pendingItem.productUrl,
                price: pendingItem.productPrice,
                product_price: pendingItem.productPrice
            };

            fetch('https://clnf.vercel.app/api/product-wishlist/add', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
                .then(async res => {
                    if (!res.ok) {
                        let errorMessage = 'Network response was not ok';
                        try {
                            const errorData = await res.json();
                            errorMessage = errorData.error || errorData.message || errorMessage;
                        } catch (e) { }
                        throw new Error(errorMessage);
                    }
                    return res.json();
                })
                .then(data => {
                    localStorage.removeItem('pendingWishlistItem');
                    // Optional: Show toast or feedback
                    // alert('Product added to your wishlist!');

                    // If we are on the account page, reload to show new data
                    if (window.location.pathname === '/account') {
                        window.location.reload();
                    }

                    // If on the same product page, update UI
                    const allButtonsForProduct = document.querySelectorAll(`.save_product_button[data-product-id="${pendingItem.productId}"]`);
                    allButtonsForProduct.forEach(b => {
                        b.classList.add('active');
                        const icon = b.querySelector('i, svg.wishlist-icon');
                        if (icon) {
                            if (icon.tagName.toLowerCase() === 'svg') {
                                icon.classList.add('filled');
                            } else {
                                icon.classList.remove('fa-heart-o');
                                icon.classList.add('fa-heart');
                            }
                        }
                        const text = b.querySelector('.save-text');
                        if (text && !text.classList.contains('sr-only')) {
                            text.textContent = 'Saved'; // For loadSavedProducts and checkPendingWishlistItems
                        }
                    });

                })
                .catch(err => {
                    console.error("Failed to add pending wishlist item:", err);
                    // We might want to keep it in localStorage to try again? 
                    // Better to remove it to avoid infinite loops of errors
                    localStorage.removeItem('pendingWishlistItem');
                });

        } catch (e) {
            console.error("Error parsing pending wishlist item:", e);
            localStorage.removeItem('pendingWishlistItem');
        }
    }

    // Call it
    checkPendingWishlistItems();

});
